<template>
  <div>
    <div class="pay_banner">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#157cfc">
        <van-swipe-item v-for="(item,index) in bannerData" :key="index"><a :href="item.url"><img :src="item.slideshow_url" alt=""></a></van-swipe-item>
      </van-swipe>
      <!-- <div class="pay_lang">
        <span></span>
        <select name="" id="" v-model="lang">
          <option value="en">EN</option>
        </select>
      </div> -->
    </div>
    <div class="pay_tab">
      <div class="cont" :class="{cont_center: prodTab.filter(item => item.show==1).length < 2}">
        <div class="tablist" :class="{list_center: item.show==0}" v-for="(item,index) in prodTab" :key="index" @click="changeTab(item,index)">
          <div v-if="item.show==1">
            <div>
            <img v-if="currIndex==index" :src="item.icon" alt="">
              <img v-else :src="item.icon1" alt="">
            </div>
            <div>{{item.name}}</div>
            <div :class="{tabcurr: currIndex==index}" class="tabheight"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="pay_module">
      <div class="module_cont">
        <div class="cont">
          <div class="cont_st">

            <div class="list" v-for="(item,index) in priceData" :key="index">
              <div class="list_le">
                <div>
                  <img :src="item.product_file_url" alt="">
                </div>
                <div class="desc">
                  <div>{{ item.product_name }}</div>
                  <div>$ {{item.amount}}</div>
                </div>
              </div>
              <div class="list_ri" @click="openDetail(item)">Buy Now</div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <cust></cust>
  </div>
</template>

<script>
// import { getPayPrice, banners, getTab } from '@/api/api';
import { getUrlParams } from '@/utils';
import { axiosServer } from '@/api/http';
import { Dialog, Toast } from 'vant';
import { getSign } from "@/api/utils";
import cust from '../../components/customer.vue'
export default{
  data() {
    return {
      priceData: [],
      bannerData: [],
      lang: 'en',
      prodTab: [{
        id: 1,
        name: 'Currency',
        icon:  require('../../assets/imgs/zf_tab_1.png'),
        icon1: require('../../assets/imgs/zf_tab_1-1.png'),
        show: 0
      },{
        id: 2,
        name: 'Packs',
        icon: require('../../assets/imgs/zf_tab_2.png'),
        icon1: require('../../assets/imgs/zf_tab_2-1.png'),
        show: 0
      }],
      currIndex: 0,
      type: 1,
      game_info: {
        game_id: '',
        area: ''
      },
      app_key: '1df869f2e620513484ddbd5521313a60',
      product_type: '',
      product_id: '',
    }
  },
  components: {
    cust
  },
  created() {
    if (getUrlParams('game_id')) {
      this.game_id = getUrlParams('game_id');
      localStorage.setItem('game_id', getUrlParams('game_id'));
    }
    if (getUrlParams('area')) {
      this.area = getUrlParams('area');
      localStorage.setItem('area', getUrlParams('area'));
    }
    if (this.$route.query.game_id) {
      localStorage.setItem('game_id', this.$route.query.game_id);
      this.game_id = this.$route.query.game_id;
      this.game_info.game_id = this.$route.query.game_id;
    }
    if (this.$route.query.area) {
      this.area = this.$route.query.area;
      localStorage.setItem('area', this.$route.query.area)
      this.game_info.area = this.$route.query.area;
    }
    this.$nextTick(() => {
      this.getBanners();
      // this.getPayPriceList();
      this.getCurrTab();
    })
    
  },
  methods: {
    getCurrTab() {
      axiosServer({
        url: "getTab",
        type: "post",
        params: {
          type: this.type,
          game_id: this.game_id,
          area: this.area,
          sign: getSign(this.app_key, { type: this.type, game_id: this.game_id, area: this.area }),
        },
      }).then((res) => {
        let resa = res.data;
        if (resa.ret == 0) {
          this.prodTab[0].show = resa.data.currency_show
          this.prodTab[1].show = resa.data.packs_show;
          this.pmx_show = resa.data.pmx_show;
          resa.data.pay_type_list && resa.data.pay_type_list.forEach((v,x) => {
            if (x == 0) {
              v.checked = true
            } else {
              v.checked = false
            }
          });
          localStorage.setItem('payWays', JSON.stringify(resa.data.pay_type_list));
          // this.$store.commit('SET_PAYMENT', resa.data.pay_type_list);
          if (resa.data.currency_show == 0) {
            this.type = 2;
            this.getPayPriceList();
          } else {
            this.getPayPriceList();
          }
          this.reportEvent(1);
        } else {
          Dialog.alert({ message: resa.msg })
        }
      })
    },
    reportEvent(event) {
      let params = {
        game_id: this.game_id,
        area: this.area,
        product_id: this.product_id,
        product_type: this.type,
        report_type: event,
      }
      axiosServer({
        url: "report",
        type: "post",
        params: {
          ...params,
          sign: getSign(this.app_key, params),
        },
      }).then((res) => {
        console.log(res)
      })
    },
    getPayPriceList() {
      Toast.loading();
      axiosServer({
        url: "getPayPrice",
        type: "post",
        params: {
          type: this.type,
          game_id: this.game_id,
          area: this.area,
          sign: getSign(this.app_key, { type: this.type, game_id: this.game_id, area: this.area }),
        },
      }).then((res) => {
        let resa = res.data;
        Toast.clear();
        if (resa.ret == 0) {
          this.priceData = resa.data;
        } else {
          Dialog.alert({ message: resa.msg })
        }
      })
    },
    getBanners() {
      axiosServer({
        url: "banners",
        type: "post",
        params: {
          type: this.type,
          game_id: this.game_id,
          area: this.area,
          sign: getSign(this.app_key, { type: this.type, game_id: this.game_id, area: this.area }),
        },
      }).then((res) => {
        let resa = res.data;
        if (resa.ret == 0) {
          this.bannerData = resa.data
        } else {
          Dialog.alert({ message: resa.msg })
        }
      })
    },
    changeTab(item,index) {
      this.currIndex = index;
      this.type = index == 0 ? 1 : 2;
      this.getPayPriceList();
      this.reportEvent(2)
    },
    openDetail(data) {
      this.$router.push({path: '/prod', query: {...data, pmx_show: this.pmx_show, type: this.type}});
      this.product_id = data.id;
      this.reportEvent(3)
    }
  }
}
</script>

<style lang="scss">
.pay_banner img{width: 100%;height: 3.18rem;}
.pay_banner .van-swipe__indicator--active{background-color: #157cfc!important;}
.pay_lang{
  position: absolute;
  right: 0.15rem;
  top: 0.15rem;
  width: 1.10rem;
  height: .34rem;
  border-radius: 0.6rem;
  background-color: #fff;
  z-index: 1;
  overflow: hidden;
  span {
    position: absolute;
    display: block;
    z-index: 999;
    width: 100%;
    height: 100%;
    text-align: center;
    right: 0.2rem;
    top: 0.1rem;
    width: 0.15rem;
    height: 0.1rem;
    background: url(../../assets/imgs/pay_select.png) center no-repeat;
    // background-size: 0.75rem auto;
  }
  select {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: .34rem;
    opacity: 0;
  }
}
.pay_tab{
  padding: 0.3rem 0.2rem 0;
  background: #fff;
  .cont {
    display: flex;
    justify-content: space-around;
    align-items: center;
    .tablist{
      img{width: 1.65rem;}
      font-size: .28rem;
      text-align: center;
      color: #010101;
      width: 3rem;
      .tabcurr{
        width: 2.12rem;
        height: 0.08rem;
        background: #4378ff;
        margin-top: 0.13rem;
        margin: 0 auto;
      }
      .tabheight{
        height: 0.08rem;
        margin-top: 0.13rem;
      }
    }
    .list_center{width: auto !important;}
  }
  .cont_center{justify-content: center !important;}
}
.pay_module{
  width: 100%;
  background: #f1f1f1;
  .module_cont{
    padding: .24rem .24rem 0;
    .cont{
      background: #fff;
      border-radius: 0.15rem;
      .cont_st{
        padding: .25rem;
        .list{
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 0.25rem;
          .list_le{
            display: flex;
            img{width: 1.59rem;}
            .desc{
              margin-left: 0.2rem;
              width: 3rem;
              div:nth-child(1) {
                color: #010101;
                font-size: 0.28rem;
                overflow-wrap: break-word;
                word-break: keep-all;
              }
              div:nth-child(2) {
                color: #ff0600;
                font-size: 0.34rem;
                margin-top: 0.1rem;
              }
            }
          }
          .list_ri{
            width: 1.47rem;
            height: .45rem;
            border-radius: 0.08rem;
            background: #4378ff;
            color: #fff;
            text-align: center;
            line-height: 0.45rem;
            font-size: .22rem;
          }
        }
      }
    }
  }
}
</style>